import { render, staticRenderFns } from "./v-navbar-navigation-item.vue?vue&type=template&id=78616d36&scoped=true&"
import script from "./v-navbar-navigation-item.vue?vue&type=script&lang=js&"
export * from "./v-navbar-navigation-item.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-navigation-item.vue?vue&type=style&index=0&id=78616d36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78616d36",
  null
  
)

export default component.exports